import React from "react";
import "./FileInfo.css";
import { formatEpochNs } from "shared/utils/datetime";

const FileInfo = ({ info }) => {
  const formatBytes = (bytes) => {
    if (!bytes) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  };

  const formatTimestamp = (nanoTime) => formatEpochNs(nanoTime);

  return (
    <div className="file-info">
      <h2>File Information</h2>
      <div className="info-grid">
        <div className="info-item">
          <span className="info-label">Profile:</span>
          <span className="info-value">{info.profile || "N/A"}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Library:</span>
          <span className="info-value">{info.library || "N/A"}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Duration:</span>
          <span className="info-value">{info.duration.toFixed(3)} seconds</span>
        </div>
        <div className="info-item">
          <span className="info-label">Message Count:</span>
          <span className="info-value">
            {info.messageCount.toLocaleString()}
          </span>
        </div>
        <div className="info-item">
          <span className="info-label">Start Time:</span>
          <span className="info-value">{formatTimestamp(info.startTime)}</span>
        </div>
        <div className="info-item">
          <span className="info-label">End Time:</span>
          <span className="info-value">{formatTimestamp(info.endTime)}</span>
        </div>
      </div>
    </div>
  );
};

export default FileInfo;
